import { Link, styled } from "@mui/material";

export const Container = styled(Link)(({ theme }) => ({}));